import { useRef } from "react";

// Lightweight touch/mouse swipe detector. Pass onSwipeLeft/onSwipeRight
// callbacks; horizontal swipes past `threshold` px trigger them.
// Spread the returned props onto the element you want to swipe on.
export default function useSwipe({ onSwipeLeft, onSwipeRight, threshold = 60 } = {}) {
  const startX = useRef(0);
  const startY = useRef(0);
  const active = useRef(false);

  const begin = (x, y) => {
    active.current = true;
    startX.current = x;
    startY.current = y;
  };

  const end = (x, y) => {
    if (!active.current) return;
    active.current = false;
    const dx = x - startX.current;
    const dy = y - startY.current;
    if (Math.abs(dx) < threshold) return;
    if (Math.abs(dx) < Math.abs(dy)) return; // ignore mostly-vertical drags
    if (dx < 0) onSwipeLeft?.();
    else onSwipeRight?.();
  };

  return {
    onTouchStart: (e) => {
      const t = e.touches?.[0];
      if (t) begin(t.clientX, t.clientY);
    },
    onTouchEnd: (e) => {
      const t = e.changedTouches?.[0];
      if (t) end(t.clientX, t.clientY);
    },
  };
}
